export enum RentalCarEquipment {
  AUTOMATIC = "premiumUpliftAutomatic",
  SAT_NAV_DAILY = "satNavDaily",
}
